import axios from "axios";
import settings from "../settings";
import { userTranslationFunctions } from "../mixins/user-translation-functions";
import router from "../router";
import Vue from "vue";

const listSettingsColumns = [
    {
        value: "code",
        text: "Product code",
        align: "left",
        isSelected: true,
    },
    {
        value: "name",
        text: "Product name",
        align: "left",
        isSelected: true,
    },
    {
        value: "product_brand",
        text: "Family",
        align: "left",
        isSelected: true,
    },
    {
        value: "product_category",
        text: "Category",
        align: "left",
        isSelected: true,
    },
    {
        value: "list_net_price",
        text: "Price list price",
        align: "left",
        isSelected: true,
    },
    {
        value: "cost_price",
        text: "Cost price",
        align: "left",
        isSelected: false,
    },
    {
        value: "own_price",
        text: "Own price",
        align: "left",
        isSelected: false,
    },
    {
        value: "export_price",
        text: "Export price",
        align: "left",
        isSelected: false,
    },
    {
        value: "accounting_class",
        text: "Accounting class",
        align: "left",
        isSelected: false,
    },
    {
        value: "ean",
        text: "EAN",
        align: "left",
        isSelected: false,
    },
    {
        value: "group_ean",
        text: "Group EAN",
        align: "left",
        isSelected: false,
    },
    {
        value: "customs_code",
        text: "Customs code",
        align: "left",
        isSelected: false,
    },
    {
        value: "eugesta_code",
        text: "Eugesta code",
        align: "left",
        isSelected: false,
    },
    {
        value: "smarten_code",
        text: "Smarten code",
        align: "left",
        isSelected: false,
    },
    {
        value: "neto_weight",
        text: "Neto weight",
        align: "left",
        isSelected: false,
    },
    {
        value: "status",
        text: "Status",
        align: "left",
        isSelected: true,
    },
];
const exportColumns = {
    general: [
        {
            value: "name",
            label: "Product name",
            isJson: false,
            isSelected: true,
        },
        {
            value: "code",
            label: "Product code",
            isJson: false,
            isSelected: true,
        },
        {
            value: "family",
            label: "Family",
            isJson: true,
            isSelected: true,
        },
        {
            value: "status",
            label: "Status",
            isJson: false,
            isSelected: true,
        },
        {
            value: "product_type",
            label: "Product type",
            isJson: false,
            isSelected: true,
        },
        {
            value: "odoo_code",
            label: "ODOO code",
            isJson: false,
            isSelected: true,
        },
        {
            value: "category",
            label: "Category",
            isJson: false,
            isSelected: true,
        },
        {
            value: "accounting_class",
            label: "Accounting class",
            isJson: true,
            isSelected: true,
        },
        {
            value: "list_net_price",
            label: "Price list price",
            isJson: false,
            isSelected: true,
        },
        {
            value: "cost_price",
            label: "Cost price",
            isJson: false,
            isSelected: true,
        },
        {
            value: "own_price",
            label: "Own price",
            isJson: false,
            isSelected: true,
        },
        {
            value: "e_shop_price",
            label: "E-shop price",
            isJson: false,
            isSelected: true,
        },
        {
            value: "base_net_price",
            label: "Base net price",
            isJson: true,
            isSelected: true,
        },
        {
            value: "export_price",
            label: "Export price",
            isJson: true,
            isSelected: true,
        },
        {
            value: "market",
            label: "Market",
            isJson: true,
            isSelected: true,
        },
        {
            value: "name_en",
            label: "Name EN",
            isJson: true,
            isSelected: true,
        },
        {
            value: "preservation_conditions_min",
            label: "Preservation conditions min",
            isJson: true,
            isSelected: true,
        },
        {
            value: "preservation_conditions_max",
            label: "Preservation conditions max",
            isJson: true,
            isSelected: true,
        },
        {
            value: "comment",
            label: "Comment",
            isJson: false,
            isSelected: true,
        },
        {
            value: "storage_life",
            label: "Storage life",
            isJson: false,
            isSelected: true,
        },
        {
            value: "odoo_category",
            label: "ODOO category",
            isJson: false,
            isSelected: true,
        },
        {
            value: "storage_conditions",
            label: "Storage conditions",
            isJson: false,
            isSelected: true,
        },
        {
            value: "launched_date",
            label: "Launched date",
            isJson: false,
            isSelected: true,
        },
        {
            value: "finished_date",
            label: "Finished date",
            isJson: false,
            isSelected: true,
        },
        {
            value: "unit",
            label: "Unit",
            isJson: false,
            isSelected: true,
        },
    ],
    package: [
        {
            value: "neto_weight",
            label: "Neto weight",
            isJson: false,
            isSelected: true,
        },
        {
            value: "package_weight",
            label: "Package weight",
            isJson: false,
            isSelected: true,
        },
        {
            value: "bruto_weight",
            label: "Bruto weight",
            isJson: false,
            isSelected: true,
        },
        {
            value: "base_height",
            label: "Base height",
            isJson: false,
            isSelected: true,
        },
        {
            value: "outer_carton_width",
            label: "Outer carton width",
            isJson: false,
            isSelected: true,
        },
        {
            value: "outer_carton_depth",
            label: "Outer carton depth",
            isJson: false,
            isSelected: true,
        },
        {
            value: "outer_carton_height",
            label: "Outer carton height",
            isJson: false,
            isSelected: true,
        },
        {
            value: "package_material",
            label: "Package material",
            isJson: false,
            isSelected: true,
        },
        {
            value: "transparent_wrap_dimensions",
            label: "Transparent wrap dimensions",
            isJson: false,
            isSelected: true,
        },
        {
            value: "transparent_wrap_length",
            label: "Transparent wrap length",
            isJson: false,
            isSelected: true,
        },
        {
            value: "transparent_wrap_width",
            label: "Transparent wrap width",
            isJson: false,
            isSelected: true,
        },
        {
            value: "transparent_wrap_comment",
            label: "Transparent wrap comment",
            isJson: false,
            isSelected: true,
        },
        {
            value: "transparent_wrap_code",
            label: "Transparent wrap code",
            isJson: false,
            isSelected: true,
        },
    ],
    "group package": [
        {
            value: "group_package_box_type",
            label: "Box type",
            isJson: false,
            isSelected: true,
        },
        {
            value: "bags_in_box",
            label: "Bags in the box",
            isJson: false,
            isSelected: true,
        },
        {
            value: "group_package_outer_carton_height",
            label: "Box height",
            isJson: false,
            isSelected: true,
        },
        {
            value: "group_package_outer_carton_depth",
            label: "Box depth",
            isJson: false,
            isSelected: true,
        },
        {
            value: "group_package_outer_carton_width",
            label: "Box width",
            isJson: false,
            isSelected: true,
        },
        {
            value: "group_package_empty_box_weight",
            label: "Empty Box weight",
            isJson: false,
            isSelected: true,
        },
        {
            value: "group_package_bruto_weight",
            label: "Group package bruto weight",
            isJson: false,
            isSelected: true,
        },
        {
            value: "group_package_box_code",
            label: "Box code",
            isJson: false,
            isSelected: true,
        },
    ],
    logistics: [
        {
            value: "boxes_in_base_layer",
            label: "Boxes in the base layer",
            isJson: false,
            isSelected: true,
        },
        {
            value: "layers_on_pallet",
            label: "Layers on the pallet",
            isJson: false,
            isSelected: true,
        },
        {
            value: "boxes_on_pallet",
            label: "Boxes on the pallet",
            isJson: false,
            isSelected: true,
        },
        {
            value: "group_package_box_code",
            label: "Box code",
            isJson: false,
            isSelected: true,
        },
    ],
    other: [
        {
            value: "has_product_label",
            label: "Has product label",
            isJson: false,
            isSelected: true,
        },
    ],
    classificators: [],
};

let new_product_data = {
    is_new: true,
    name: null,
    code: null,
    status: "inactive",
    product_type: "product",
    odoo_code: null,
    list_net_price: null,
    cost_price: null,
    own_price: null,
    e_shop_price: null,
    product_category_id: null,
    neto_weight: null,
    bags_in_box: null,
    boxes_in_base_layer: null,
    layers_on_pallet: null,
    boxes_on_pallet: null,
    outer_carton_height: null,
    outer_carton_depth: null,
    outer_carton_width: null,
    comment: null,
    storage_life: null,
    odoo_category: null,
    storage_conditions: null,
    launched_date: null,
    finished_date: null,
    transparent_wrap_dimensions: null,
    transparent_wrap_length: null,
    transparent_wrap_width: null,
    transparent_wrap_comment: null,
    transparent_wrap_code: null,
    has_product_label: false,
    base_height: null,
    export_price: null,
    unit: null,
    data: {
        family: null,
        accounting_class: null,
        preservation_conditions_min: null,
        preservation_conditions_max: null,
        market: null,
        name_en: null,
        base_net_price: null,
    },
};
const newPriceData = {
    id: null,
    start_date: new Date(),
    value: 0,
    product_type: null,
};
let initialState = {
    exportMode: false,
    priceMode: false,
    exportModal: false,
    productsBulkPriceEditModal: false,
    exportProducts: [],
    exportColumns: exportColumns,
    listSettingsModal: false,
    listSettingsColumns: listSettingsColumns,
    productsTableHeaders: [],
    loadingProductList: false,
    loadingProductData: false,
    requestSuccess: false,
    requestError: false,
    errorMessage: "",
    drawerOpen: false,
    activeProduct: {},
    products: [],
    productCategories: [],
    productBrands: [],
    productClassificators: [],
    searchProductStrings: [],
    imageFile: null,
    files: [],
    tableOptions: null,
    totalProductCount: 0,
    statusForFiltering: ["active", "in development", "inactive", "special order", "private label"],
    productTypes: ["product", "raw_material", "other"],
    selectedProductTypeIndex: 0,
    priceModal: false,
    priceModalType: "price",
    priceData: [],
};
let cancelDataRequest = null;
export default {
    namespaced: true,
    state: { ...initialState },
    mixins: [userTranslationFunctions],
    actions: {
        async getProductList({ commit, state }, { options = null, searchStrings = null }) {
            commit("setProductListLoading", true);
            if (cancelDataRequest) {
                cancelDataRequest();
            }
            const CancelToken = axios.CancelToken;
            let params = {
                searchStrings: searchStrings,
                page: options && options.page ? options.page : 1,
                itemsPerPage: options && options.itemsPerPage ? options.itemsPerPage : 50,
                sortBy: options && options.sortBy[0] ? options.sortBy[0] : null,
                sortDesc: options && options.sortDesc ? options.sortDesc[0] : null,
                productType: state.productTypes[state.selectedProductTypeIndex],
            };
            try {
                let response = await axios.get(settings.api_url + "/products", {
                    params,
                    cancelToken: new CancelToken((c) => {
                        cancelDataRequest = c;
                    }),
                });
                if (response.status === 200) {
                    cancelDataRequest = null;
                    let data = response.data;
                    commit("addProducts", data.products);
                    commit("addProductCategories", data.categories);
                    commit("addProductBrands", data.brands);
                    commit("addProductClassificators", data.classificator_fields);
                    if (Object.keys(data.classificator_fields).length > 0) {
                        commit("addClassificatorsToExportColumns", data.classificator_fields);
                    }
                    if (data.user_product_xlsx_settings) {
                        commit("setProductXlsxSettings", data.user_product_xlsx_settings);
                    }
                    if (data.user_product_search_settings) {
                        commit("setMountedTableHeaders", data.user_product_search_settings);
                    } else {
                        commit("setProductsTableHeaders");
                    }
                    commit("setProductListLoading", false);
                    commit("setTotalProductCount", data.total_product_count);
                }
            } catch (e) {
                console.log(e);
                commit("setProductListLoading", false);
            }
        },
        async getProductData({ commit }, productId) {
            commit("setProductDataLoading", true);
            try {
                let response = await axios.get(settings.api_url + "/product/" + productId);
                if (response && response.data && response.status === 200) {
                    let data = response.data;
                    commit("setActiveProduct", data.product_data);
                }
                commit("setProductDataLoading", false);
            } catch (e) {
                console.log(e);
                commit("setProductDataLoading", false);
            }
        },
        async submitProductUpdate({ commit, dispatch }, { product, image }) {
            let formData = new FormData();
            formData.append("file", image);
            formData.append("data", JSON.stringify(product));

            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            try {
                let response = await axios.post(settings.api_url + "/product/", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                if (response.status === 200) {
                    if (response.data.success === 1) {
                        commit("setRequestSuccess", true);
                        commit("setImageFile", { image: null });
                        return { status: 1, id: response.data.product_id };
                    } else {
                        commit("setRequestError", true);
                        commit("setErrorMessage", response.data.error_msg);
                        return { status: 0 };
                    }
                }
            } catch (e) {
                console.log(e);
            }
        },
        async submitFileUpdate({ commit, dispatch }, { product, files }) {
            let formData = new FormData();
            files.map((f, idx) => {
                formData.append("files[" + idx + "]", f);
            });

            formData.append("related_id", JSON.stringify(product.id));
            formData.append("related_type", JSON.stringify("product"));
            commit("setRequestSuccess", false);
            try {
                let response = await axios.post(settings.api_url + "/file", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                if (response.status === 200) {
                    dispatch("getProductList");
                    dispatch("getProductData", product.id);
                    commit("setRequestSuccess", true);
                    commit("resetFiles", true);
                }
            } catch (e) {
                console.log(e);
            }
        },
        async removeFile({ commit, dispatch }, { file_id, product_id }) {
            commit("setRequestSuccess", false);
            try {
                let response = await axios.delete(settings.api_url + "/file?file_id=" + file_id);
                if (response.status === 200) {
                    dispatch("getProductData", product_id);
                    commit("setRequestSuccess", true);
                }
            } catch (e) {
                console.log(e);
            }
        },
        async createDuplicate({ commit, dispatch }, { product_id }) {
            commit("setRequestSuccess", false);
            try {
                const response = await axios.put(settings.api_url + "/product/", {
                    action: "duplicate",
                    product_id: product_id,
                });

                if (response.status === 200) {
                    dispatch("getProductData", response.data.product_id);
                    commit("setRequestSuccess", true);
                    return { status: 1, id: response.data.product_id };
                } else {
                    return { status: 0 };
                }
            } catch (e) {
                console.log(e);
            }
        },
        async deleteProduct({ commit, dispatch }, { product_id }) {
            commit("setRequestSuccess", false);
            try {
                const response = await axios.delete(settings.api_url + "/product/", {
                    params: { product_id },
                });

                if (response.status === 200) {
                    commit("setRequestSuccess", true);
                    return { status: 1 };
                } else {
                    return { status: 0 };
                }
            } catch (e) {
                console.log(e);
            }
        },
        async sendProductToWordpress({ commit, dispatch }, { product_id }) {
            await commit("setRequestSuccess", false);
            await commit("setProductDataLoading", true);

            try {
                const response = await axios.get(settings.api_url + "/product-export-to-wordpress/" + product_id);

                if (response.status === 200) {
                    commit("setRequestSuccess", true);
                }
                await commit("setProductDataLoading", false);

                return response.data;
            } catch (e) {
                console.log(e);
            }
            await commit("setProductDataLoading", false);
        },
        async importProductsExcel({ commit, dispatch, state }, e) {
            commit("setProductListLoading", true);

            let formData = new FormData();
            formData.append("file", e);
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            try {
                let response = await axios.post(settings.api_url + "/import-products-excel/", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });
                if (response.status === 200) {
                    if (response.data.success === 1) {
                        commit("setRequestSuccess", true);
                        dispatch("getProductList", {
                            options: state.tableOptions,
                            searchStrings: state.searchProductStrings,
                        });
                    } else {
                        commit("setRequestError", true);
                        commit("setErrorMessage", response.data.error_msg);
                    }
                }
            } catch (e) {
                console.log(e);
            }
            await commit("setProductListLoading", false);
        },
        async getPriceTypeData({ commit, state }) {
            commit("setRequestError", false);
            try {
                let response = await axios.get(settings.api_url + "/product-price/" + state.activeProduct.id, {
                    params: {
                        type: state.priceModalType,
                    },
                });
                if (response.data.success === 1) {
                    commit("setPriceData", response.data.price_data);
                }
            } catch (e) {
                console.log(e);
                //commit("setProductListLoading", false);
            }
        },
        async saveProductPriceData({ commit, state }, data) {
            commit("setRequestError", false);
            try {
                let response = await axios.post(
                    settings.api_url + "/product-price/" + state.activeProduct.id,
                    {
                        prices: data,
                    },
                    {
                        params: {
                            type: state.priceModalType,
                        },
                    }
                );
                let bool = false;
                response.data && response.data.success === 1 ? (bool = true) : (bool = false);
                return bool;
            } catch (e) {
                console.log(e);
                //commit("setProductListLoading", false);
            }
        },
        async saveBulkProductPrices({ commit, state }, data) {
            commit("setRequestError", false);
            commit("setRequestSuccess", false);
            try {
                let response = await axios.post(settings.api_url + "/bulk-product-price/", data);
                let bool = false;
                response.data && response.data.success === 1 ? (bool = true) : (bool = false);
                return bool;
            } catch (e) {
                console.log(e);
                //commit("setProductListLoading", false);
            }
            return false;
        },
    },
    mutations: {
        setProductsTableHeaders(state) {
            state.productsTableHeaders = [];
            state.listSettingsColumns.map((x) => {
                if (x.isSelected) {
                    x.align = "left";
                    state.productsTableHeaders.push(x);
                }
            });
            const length = state.productsTableHeaders.length;
            if (length > 2) {
                state.productsTableHeaders[length - 1].align = "center";
                state.productsTableHeaders[length - 2].align = "end";
            }
            let status = state.productsTableHeaders.find((x) => x.value === "status");
            if (status) {
                status.statuses = state.statusForFiltering;
            }
        },
        setMountedTableHeaders(state, value) {
            state.productsTableHeaders = value;
            let selected_array = state.productsTableHeaders.map((x) => x.value);
            state.listSettingsColumns.forEach((x) => {
                x.isSelected = selected_array.includes(x.value);
            });
            let status = state.productsTableHeaders.find((x) => x.value === "status");
            if (status && status.statuses) {
                state.statusForFiltering = status.statuses;
            }
        },
        setStatusForFiltering(state, value) {
            state.statusForFiltering = value;
        },
        setTableOptions(state, options) {
            state.tableOptions = options;
            this.dispatch("ProductStore/getProductList", {
                options: state.tableOptions,
                searchStrings: state.searchProductStrings,
            });
        },
        setFiles(state, payload) {
            state.files = payload.value;
        },
        setTotalProductCount(state, count) {
            state.totalProductCount = count;
        },
        resetFiles(state) {
            state.files = [];
        },
        setImageFile(state, payload) {
            state.imageFile = payload.value;
            if (payload.value === undefined) {
                state.imageFile = null;
                state.activeProduct.image = null;
                state.activeProduct.image_path = null;
            }
        },
        setRequestSuccess(state, bool) {
            state.requestSuccess = bool;
        },
        setRequestError(state, bool) {
            state.requestError = bool;
        },
        setErrorMessage(state, msg) {
            state.errorMessage = msg;
        },
        toggleExportMode(state) {
            state.exportMode = !state.exportMode;
        },
        togglePriceMode(state) {
            state.priceMode = !state.priceMode;
        },
        toggleProductsBulkPriceEditModal(state) {
            state.productsBulkPriceEditModal = !state.productsBulkPriceEditModal;
        },
        toggleExportModal(state) {
            state.exportModal = !state.exportModal;
        },
        toggleListSettingsModal(state) {
            state.listSettingsModal = !state.listSettingsModal;
        },
        setExportProducts(state, products) {
            state.exportProducts = products;
        },
        resetExportProducts(state) {
            state.exportProducts = [];
        },
        addProducts(state, products) {
            state.products = products;
        },
        addProductCategories(state, categories) {
            state.productCategories = categories;
            state.productCategories.unshift("Not set");
        },
        addProductBrands(state, brands) {
            state.productBrands = brands;
            state.productBrands.unshift("Not set");
        },

        addProductClassificators(state, classificators) {
            state.productClassificators = classificators;
        },
        setActiveProduct(state, product) {
            state.activeProduct = { ...product };
        },
        toggleDrawer(state, isOpen) {
            state.drawerOpen = isOpen;
        },
        resetActiveProduct(state) {
            state.activeProduct = {};
        },
        addNewProduct(state) {
            state.activeProduct = new_product_data;
        },
        updateActiveProductProperty(state, { prop, value }) {
            state.activeProduct = {
                ...state.activeProduct,
                [prop]: value,
            };
        },
        updateActiveProductJsonField(state, { prop, value }) {
            state.activeProduct.data = {
                ...state.activeProduct.data,
                [prop]: value,
            };
        },
        updateProductSearch(state, payload) {
            state.searchProductStrings = payload.term;
            this.dispatch("ProductStore/getProductList", {
                options: state.tableOptions,
                searchStrings: state.searchProductStrings,
            });
        },
        resetProductSearch(state) {
            state.searchProductStrings = [];
        },
        setProductListLoading(state, value) {
            state.loadingProductList = value;
        },
        setProductDataLoading(state, value) {
            state.loadingProductData = value;
        },
        /** cr_object is classificator row object */
        changeClassificatorValue(state, { value, classificator_row, classificator_type }) {
            if (value === "<p></p>") {
                value = null;
            }

            let classificator_values = null;
            if (!state.activeProduct.data[classificator_type]) {
                classificator_values = [];
            } else {
                classificator_values = state.activeProduct.data[classificator_type].slice(0);
            }
            let cr_value_object_index = classificator_values.findIndex(
                (crv) => crv.classificator_row_id === classificator_row.id
            );
            if (cr_value_object_index === -1) {
                let cr_value_object = {
                    classificator_row_id: classificator_row.id,
                    value: value,
                };
                classificator_values.push(cr_value_object);
            } else {
                classificator_values[cr_value_object_index] = {
                    classificator_row_id: classificator_row.id,
                    value: value,
                };
            }
            state.activeProduct.data = {
                ...state.activeProduct.data,
                [classificator_type]: classificator_values,
            };
        },
        addClassificatorsToExportColumns(state, classificators) {
            let returnArray = [];
            Object.values(classificators).map((pc) => {
                let pcObj = {};
                if (pc.classificator_type !== "allergens") {
                    pcObj = {
                        value: pc.classificator_type,
                        label: pc.title,
                        rows: [],
                    };

                    pc.rows.map((pcRow) => {
                        pcObj.rows.push({
                            value: pcRow.value,
                            label: pcRow.title,
                            pcRowId: pcRow.id,
                            isSelected: true,
                        });
                    });
                } else {
                    pcObj = {
                        value: pc.classificator_type,
                        label: pc.title,
                        isSelected: true,
                    };
                }

                returnArray.push(pcObj);
            });
            state.exportColumns.classificators = returnArray;
        },
        toggleExportColumn(state, { type, item, isClassificator }) {
            if (!isClassificator) {
                let column = state.exportColumns[type].find((c) => c.value === item.value);
                column.isSelected = !column.isSelected;
            } else {
                if (type !== "allergens") {
                    let classificatorParent = state.exportColumns.classificators.find((c) => c.value === type);
                    let classificatorItem = classificatorParent.rows.find((ci) => ci.pcRowId === item.pcRowId);
                    classificatorItem.isSelected = !classificatorItem.isSelected;
                } else {
                    let classificatorParent = state.exportColumns.classificators.find((c) => c.value === type);
                    classificatorParent.isSelected = !classificatorParent.isSelected;
                }
            }
        },
        toggleListSettingsColumn(state, item) {
            let column = state.listSettingsColumns.find((c) => c.value === item.value);
            column.isSelected = !column.isSelected;
        },
        setAllExportColumnSelect(state, select) {
            Object.entries(state.exportColumns).forEach(([key]) => {
                state.exportColumns[key].forEach((c) => {
                    if (key !== "classificators") {
                        c.isSelected = select;
                    } else {
                        if (c.value !== "allergens") {
                            c.rows.forEach((ci) => (ci.isSelected = select));
                        } else {
                            c.isSelected = select;
                        }
                    }
                });
            });
        },
        setProductXlsxSettings(state, settings) {
            let notSelectedArray = [];
            Object.keys(settings).map((category) => {
                let category_columns = settings[category];
                category_columns.map((col) => {
                    if (col.isSelected === false) notSelectedArray.push(col.value);
                });
            });
            let freshArray = { ...exportColumns };
            Object.values(freshArray).map((c) => {
                c.map((cc) => {
                    if (notSelectedArray.includes(cc.value)) {
                        cc.isSelected = false;
                    }
                });
            });
            state.exportColumns = freshArray;
        },
        setPriceModal(state, bool) {
            state.priceModal = bool;
        },
        setPriceModalType(state, value) {
            state.priceModalType = value;
        },
        setPriceData(state, value) {
            state.priceData = value;
        },
        addPriceEntry(state, payload) {
            const id = "X" + Math.round(Math.random() * 10000);
            state.priceData.push({
                ...newPriceData,
                product_type: state.priceModalType,
                id: id,
                start_date: payload.date,
                value: payload.value,
            });
        },
        removePriceEntry(state, index) {
            state.priceData.splice(index, 1);
        },
        updatePriceDataValue(state, { prop, value, index }) {
            state.priceData[index] = {
                ...state.priceData[index],
                [prop]: value,
            };
        },
        setSelectedProductTypeIndex(state, index) {
            state.selectedProductTypeIndex = index;
            this.dispatch("ProductStore/getProductList", {
                options: state.tableOptions,
                searchStrings: state.searchProductStrings,
            });
        },
    },
    getters: {
        productCount: (state) => {
            return state.products.length;
        },
        exportProductIdString: (state) => {
            let productIdArray = state.exportProducts.map((ep) => ep.id);
            return productIdArray.join(",");
        },
        exportColumnObject: (state) => {
            let returnData = {
                default_fields: [],
                classificators: [],
            };
            Object.entries(state.exportColumns).map((ec) => {
                if (ec[0] !== "classificators") {
                    ec[1].map((field) => {
                        if (field.isSelected) {
                            returnData.default_fields.push(field.value);
                        }
                    });
                } else {
                    ec[1].map((c) => {
                        if (c.value !== "allergens") {
                            c.rows.map((cr) => {
                                if (cr.isSelected) {
                                    returnData.classificators.push(cr.pcRowId);
                                }
                            });
                        } else {
                            if (c.isSelected) {
                                returnData.classificators.push("allergens");
                            }
                        }
                    });
                }
            });
            return returnData;
        },
    },
    methods: {
        getClassificatorOrClassificatorRowTitle(classificatorTitle) {
            classificatorTitle = JSON.parse(classificatorTitle);
            if (classificatorTitle.et) {
                return classificatorTitle.et;
            } else {
                return classificatorTitle.en;
            }
        },
    },
};
